import React from "react";

const StarIconCircle = ({
  width = 41,
  height = 40,
  fill = "#EE8113",
  color = "#EE8113",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_449_2841)">
        <path
          d="M39.5 20C39.5 9.50659 30.9934 1 20.5 1C10.0066 1 1.5 9.50659 1.5 20C1.5 30.4934 10.0066 39 20.5 39C30.9934 39 39.5 30.4934 39.5 20Z"
          fill="white"
        />
        <path
          d="M39.5 20C39.5 9.50659 30.9934 1 20.5 1C10.0066 1 1.5 9.50659 1.5 20C1.5 30.4934 10.0066 39 20.5 39C30.9934 39 39.5 30.4934 39.5 20Z"
          stroke={color}
          strokeWidth="2"
        />
        <g clipPath="url(#clip1_449_2841)">
          <path
            d="M30.5234 17.2771C30.9538 16.8534 31.1057 16.2317 30.9201 15.6545C30.7343 15.0773 30.2494 14.6646 29.6547 14.5773L24.454 13.8142C24.3519 13.7993 24.2636 13.7345 24.2179 13.6411L21.8921 8.88232C21.6261 8.33808 21.0876 8 20.4865 8C19.8855 8 19.3469 8.33808 19.0809 8.88232L16.7551 13.6411C16.7094 13.7345 16.6211 13.7993 16.519 13.8143L11.3184 14.5773C10.7236 14.6646 10.2388 15.0773 10.053 15.6545C9.86724 16.2317 10.0192 16.8534 10.4497 17.2771L14.2129 20.9813C14.2868 21.054 14.3205 21.1588 14.3031 21.2615L13.4147 26.4919C13.3131 27.0901 13.552 27.6832 14.0382 28.04C14.5245 28.3968 15.1571 28.4429 15.689 28.1605L20.3406 25.6911C20.432 25.6426 20.5411 25.6426 20.6325 25.6911L25.2841 28.1605C25.5155 28.2834 25.7659 28.3441 26.015 28.3441C26.3385 28.3441 26.6601 28.2416 26.9348 28.0399C27.4211 27.6831 27.6599 27.0899 27.5583 26.4918L26.6699 21.2615C26.6525 21.1588 26.6862 21.054 26.7601 20.9813L30.5234 17.2771ZM25.4341 21.4756L26.3225 26.7061C26.3523 26.8811 26.2452 26.9809 26.1978 27.0156C26.1504 27.0504 26.0233 27.1224 25.8677 27.0397L21.216 24.5703C20.9877 24.4491 20.7372 24.3884 20.4866 24.3884C20.236 24.3884 19.9855 24.4491 19.7572 24.5702L15.1056 27.0396C14.9499 27.1223 14.8228 27.0503 14.7754 27.0155C14.728 26.9809 14.621 26.881 14.6507 26.706L15.5391 21.4756C15.6264 20.9621 15.4579 20.4384 15.0883 20.0746L11.3251 16.3705C11.1991 16.2464 11.2276 16.1022 11.2458 16.0459C11.2638 15.9896 11.3248 15.856 11.4988 15.8305L16.6994 15.0674C17.21 14.9924 17.6513 14.6688 17.8797 14.2015L20.2055 9.44269C20.2834 9.28345 20.428 9.26625 20.4866 9.26625C20.5452 9.26625 20.6898 9.2834 20.7677 9.44269L23.0936 14.2015C23.3219 14.6688 23.7631 14.9925 24.2737 15.0674L29.4744 15.8305C29.6485 15.856 29.7094 15.9897 29.7275 16.046C29.7456 16.1023 29.7741 16.2465 29.6481 16.3705L25.8849 20.0746C25.5153 20.4384 25.3469 20.9621 25.4341 21.4756Z"
            fill={color}
          />
          <path
            d="M27.8117 8.88389C27.5316 8.67837 27.1395 8.7411 26.936 9.02396L26.2704 9.94893C26.0669 10.2318 26.129 10.6278 26.4091 10.8333C26.5205 10.9149 26.6494 10.9542 26.7771 10.9542C26.9711 10.9542 27.1622 10.8637 27.2849 10.6932L27.9504 9.76827C28.154 9.48537 28.0919 9.08939 27.8117 8.88389Z"
            fill={color}
          />
          <path
            d="M14.7007 9.94557L14.0351 9.02059C13.8317 8.73783 13.4396 8.6751 13.1594 8.88052C12.8792 9.08603 12.8171 9.482 13.0207 9.76486L13.6862 10.6898C13.8089 10.8604 14.0001 10.9509 14.194 10.9509C14.3218 10.9509 14.4508 10.9116 14.562 10.8299C14.8421 10.6244 14.9043 10.2285 14.7007 9.94557Z"
            fill={color}
          />
          <path
            d="M10.9043 22.2059C10.7973 21.8734 10.4436 21.6914 10.1143 21.7995L9.0374 22.1528C8.70803 22.2609 8.52786 22.6181 8.63487 22.9507C8.72093 23.2182 8.96674 23.3883 9.23103 23.3883C9.29523 23.3883 9.36055 23.3783 9.42494 23.3571L10.5018 23.0037C10.8311 22.8957 11.0113 22.5385 10.9043 22.2059Z"
            fill={color}
          />
          <path
            d="M20.4868 29.2361C20.1405 29.2361 19.8599 29.5195 19.8599 29.8692V31.0126C19.8599 31.3622 20.1405 31.6457 20.4868 31.6457C20.8331 31.6457 21.1138 31.3622 21.1138 31.0126V29.8692C21.1138 29.5194 20.8331 29.2361 20.4868 29.2361Z"
            fill={color}
          />
          <path
            d="M31.9381 22.1528L30.8612 21.7994C30.532 21.6915 30.1781 21.8734 30.0711 22.2059C29.9642 22.5385 30.1443 22.8957 30.4737 23.0038L31.5505 23.3571C31.6149 23.3782 31.6802 23.3882 31.7444 23.3882C32.0088 23.3882 32.2546 23.2181 32.3406 22.9506C32.4476 22.618 32.2674 22.2609 31.9381 22.1528Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export default StarIconCircle;
